import _path from 'ramda/src/path';
import React from 'react';
import PropTypes from 'prop-types';
import Avatar from './Avatar';
import DateFromNow from './DateFromNow';
import resx from '../../utilities/resx';
import Tooltip from './Tooltip';
import UserInfo from './UserInfo';
import { RESX_REBLASTS } from '../../Constants';

const IdBar = props => {
    const { date, GroupLinkPublicPage, GroupName, HideFirmFeed, lazy, IsScrubbed } = props;
    const {
        City,
        Country,
        CountryId,
        FirstName,
        FirmName,
        FullName,
        FirmUniqueName,
        HasProfileBadge,
        HasPremiumPlusBadge,
        LastName,
        Latitude,
        Longitude,
        State,
        UserDomain,
        UserProfilePictureUrl,
        WebsiteId,
        InstantReferralAuthorVerified,
        Connected
    } = props.user;

    const formattedName = FullName || `${FirstName} ${LastName}`;
    let locationFormatted, locationLink;
    if (City && Latitude && Longitude) {
        locationLink = `/agents/location/${City}/${State || ''}?Latitude=${Latitude}&Longitude=${Longitude}`;
    }

    if (City) {
        if (Country && CountryId && CountryId !== _path(['User2', 'CountryId'], RESAAS)) {
            locationFormatted = `${City}, ${Country}`;
        } else if (State) {
            locationFormatted = `${City}, ${State}`;
        } else {
            locationFormatted = City;
        }
    }

    return (
        <div className="re-idbar">
            {!IsScrubbed && (
                <div className="re-idbar-avatar" title={formattedName}>
                    {(UserProfilePictureUrl || WebsiteId) && (
                        <Tooltip
                            mixpanelType="user-info-tooltip"
                            overlay={
                                WebsiteId ? (
                                    <UserInfo WebsiteId={WebsiteId} Domain={UserDomain} FirstName={FirstName} />
                                ) : (
                                    <UserInfo Domain={UserDomain} FirstName={FirstName} />
                                )
                            }
                        >
                            <Avatar
                                displayName={formattedName}
                                hasProfileBadge={HasProfileBadge}
                                hasPremiumPlusBadge={HasPremiumPlusBadge}
                                size="sm"
                                src={typeof UserProfilePictureUrl === 'string' ? UserProfilePictureUrl : undefined}
                                websiteId={typeof WebsiteId === 'number' ? WebsiteId : undefined}
                                lazy={lazy}
                            />
                        </Tooltip>
                    )}
                </div>
            )}
            {IsScrubbed && (
                <span className="re-idbar-avatar">
                    <Avatar
                        displayName={''}
                        size="sm"
                        src={'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/realtors/website/0/2/981/profile.png'}
                        lazy={lazy}
                    />
                </span>
            )}
            <div className="re-idbar-info">
                {!IsScrubbed && (
                    <div className="re-idbar-info-container">
                        <Tooltip
                            mixpanelType="user-info-tooltip"
                            overlay={
                                WebsiteId ? (
                                    <UserInfo WebsiteId={WebsiteId} Domain={UserDomain} FirstName={FirstName} />
                                ) : (
                                    <UserInfo Domain={UserDomain} FirstName={FirstName} />
                                )
                            }
                        >
                            <span className="re-idbar-name notranslate" >{formattedName}{' '}
                            </span>
                        </Tooltip>
                        {/* we dont show group info if we are in a group page or the group info is for resaas-commercial group */}
                        {GroupLinkPublicPage && window.location.pathname.indexOf('/group') === -1 && GroupLinkPublicPage.indexOf('/group/resaas-commercial') === -1 ? (
                            <div className="re-idbar-info-group">
                                <span>&nbsp;in&nbsp;</span>
                                <a
                                href={GroupLinkPublicPage}
                                title={GroupName}
                                dangerouslySetInnerHTML={{ __html: GroupName }}
                                className="re-text-bold"
                                data-testid="grouplink"
                                />
                            </div>) : null}                        
                    </div>
                )}
                {IsScrubbed && (
                    <span className="re-idbar-name notranslate">
                        {formattedName}
                        {InstantReferralAuthorVerified && (
                            <span>
                                {' '}
                                <i className="re-icon re-icon-solid re-icon-sm re-icon-primary re-icon-check-circle" />
                            </span>
                        )}
                    </span>
                )}
                <ul className="re-idbar-details notranslate">
                    {!IsScrubbed && <li className="re-idbar-detail">@{UserDomain}</li>}
                    {!IsScrubbed &&
                        FirmName &&
                        !HideFirmFeed && (
                            <li className="re-idbar-detail re-idbar-detail-mobileview notranslate" data-testid="firmlink">
                                {FirmUniqueName ? (
                                    <a
                                        href={`/agents/firm/${FirmUniqueName}/?_subjectName=${FirmName}`}
                                        dangerouslySetInnerHTML={{ __html: FirmName }}
                                    />
                                ) : (
                                    FirmName
                                )}
                            </li>
                        )}
                    {locationFormatted ? (
                        <li className="re-idbar-detail" data-testid="locationformatted">
                            {locationLink ? (
                                <a href={locationLink} data-testid="locationlink">
                                    {locationFormatted}
                                </a>
                            ) : (
                                locationFormatted
                            )}
                        </li>
                    ) : null}
                    {date && (
                        <li className="re-idbar-detail re-idbar-detail-mobileview" data-testid="date">
                            <DateFromNow date={date} />
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};

IdBar.propTypes = {
    HideFirmFeed: PropTypes.bool,
    user: PropTypes.object.isRequired,
    date: PropTypes.string,
    GroupName: PropTypes.string,
    GroupLinkPublicPage: PropTypes.string,
    lazy: PropTypes.bool,
    IsScrubbed: PropTypes.bool
};

export default IdBar;
